import client from "./client";

export const fetchWebsitePromotions = (params = {}, options = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    searchParams.set(key, value);
  });
  const suffix = searchParams.toString() ? `?${searchParams.toString()}` : "";
  return client.get(`/website/promotions${suffix}`, options);
};

export const trackWebsitePromotionEvent = (payload = {}, options = {}) =>
  client.post("/website/promotions/events", payload, {
    keepalive: true,
    ...(options || {}),
  });

const websitePromotionsApi = {
  fetchWebsitePromotions,
  trackWebsitePromotionEvent,
};

export default websitePromotionsApi;
